import React from 'react';

const RELEASES = [
  { id: '43015', title: 'CoreAge Rx Elevates Telehealth Experience...', package: 'Basic', date: '2 days ago' },
  { id: '43013', title: 'CoreAge Rx Strengthens Nationwide Telehealth...', package: 'Basic', date: '2 days ago' },
  { id: '43012', title: 'CoreAge Rx Highlighted Across Independent Reviews...', package: 'Basic', date: '2 days ago' },
  { id: '43010', title: 'CoreAge Rx Gains Recognition Across Multiple...', package: 'Basic', date: '2 days ago' },
];

export default function ViewPressReleases() {
  return (
    <div style={styles.container}>
      <div style={styles.headerRow}>
        <h2 style={styles.pageTitle}>Press Releases Reports</h2>
        <input style={styles.searchInput} placeholder="Search Press Release..." />
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>PR No.</th>
              <th>Press Release Title</th>
              <th>Package Name</th>
              <th>Date</th>
              <th>View Reports</th>
            </tr>
          </thead>
          <tbody>
            {RELEASES.map((pr, i) => (
              <tr key={i}>
                <td>{pr.id}</td>
                <td>{pr.title}</td>
                <td>{pr.package}</td>
                <td>{pr.date}</td>
                <td><button className="btn btn-primary" style={styles.viewBtn}>View Reports</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '1200px' },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  pageTitle: { fontSize: '1.25rem', color: '#333' },
  searchInput: { padding: '0.6rem 1rem', border: '1px solid #e5e7eb', borderRadius: '4px', width: '300px', outline: 'none' },
  viewBtn: { padding: '0.4rem 0.8rem', fontSize: '0.8rem' }
};
